import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useGetAllContacts } from '../../../services/react-query/contacts';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { Contact } from '../../../types/Contact';

interface IAddContactModalProps {
  accountUuid: string;
  open: boolean;
  alreadyAddedContacts: string[];
  onClose: () => void;
  onAdd: (contacts: Contact[]) => void;
}

export default function AddContactModal({ accountUuid, open, alreadyAddedContacts, onClose, onAdd }: IAddContactModalProps) {
  const { data: contactsResponse } = useGetAllContacts({ params: { filters: { account: accountUuid } } });

  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);

  const selectableContacts = _.reject(contactsResponse?.data, (contact: Contact) => _.includes(alreadyAddedContacts, contact.uuid));

  useEffect(() => {
    if (!open) {
      setSelectedContact(null);
    }
  }, [open]);

  const handleAdd = () => {
    if (!selectedContact) return;

    onAdd([selectedContact]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContentText>
        <Typography {...headerTypographyProps} sx={{ ml: 2, mt: 2 }}>
          Select Contact To Add
        </Typography>
        <Typography sx={{ ml: 2, mt: 1 }}>Please select the contact you would like to associate with this event.</Typography>
      </DialogContentText>
      <DialogContent>
        <Autocomplete
          options={selectableContacts}
          value={selectedContact}
          getOptionLabel={(contact: Contact) => contact.full_name || ''}
          onChange={(_, value) => {
            setSelectedContact(value);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', mx: 1 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={!selectedContact} onClick={handleAdd}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
